import { render, staticRenderFns } from "./DashboardCardInsights.vue?vue&type=template&id=46e2f5f0&"
import script from "./DashboardCardInsights.vue?vue&type=script&lang=js&"
export * from "./DashboardCardInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports